import {FC, useEffect, useMemo, useState} from "react";
import useAvailableChannelsPage from "../../hooks/channel/useAvailableChannels.ts";
import {IsLoadingContainer} from "../../container/IsLoadingContainer.tsx";
import {AvailableChannelsType, IChannelResponseData} from "../../state/models/ChannelResponse.ts";
import {ICategoriesResponseData} from "../../state/models/CategoriesResponse.ts";
import {CustomPageHeader} from "../CustomPageHeader.tsx";
import {EmptySearchChannelResult} from "../EmptySearchChannelResult.tsx";
import {ButtonsBottomBlockOfPage} from "../ButtonsBottomBlockOfPage.tsx";
import {CommonFilterBtnBlock} from "../CommonFilterBtnBlock.tsx";
import {AvailableChannelCard} from "../cards/AvailableChannelCard.tsx";
import {ModalPropsType, useModal} from "../../context/ModalContext.tsx";
import {motion} from "framer-motion";
import {publicationActions} from "../../state/reducers/singlePublication-reducer.ts";
import {useTranslation} from "react-i18next";

export type AvailableChannelsFilterType = "all" | "chosen" | "notChosen"

export type AvailableChannelsDataFilterType = {
    id: number
    title: string
    border: boolean
    filterVal: AvailableChannelsFilterType
}


export const AvailableChannels: FC<ModalPropsType> = ({onClose, modalId}) => {
    const {
        isLoading,
        openSearchModal,
        channelsData,
        categoriesData,
        toggleCheckBox,
        resetForm,
        dispatch
    } = useAvailableChannelsPage()
    const {closeModal} = useModal();

    // просто закрыть (без submitFormFunc)
    const handleJustClose = () => {
        if (modalId) {
            closeModal(modalId); // вручную
        }
    };
    // вызвать submitFormFunc, а потом закрыть
    const handleSubmitAndClose = () => {
        const storedChannelsObj = localStorage.getItem('selectedChannels');
        const storedChannels = storedChannelsObj && JSON.parse(storedChannelsObj).map((item: IChannelResponseData) => item.id);

        if (storedChannelsObj && storedChannels.length > 0) {
            onClose();
        } else {
            dispatch(publicationActions.setCheckedChannels(true))
        }
    };
    const {t} = useTranslation();


    useEffect(() => {
        return () => {
            localStorage.removeItem('selectedChannels')
        }
    }, []);

    return (
        <div
            className="absolute inset-0 z-[99999] flex items-center justify-center bg-black/50 backdrop-blur-sm"
            onClick={handleJustClose}
        >
            <motion.div
                className="w-full h-full bg-[var(--default-page-color)] flex flex-col"
                initial={{y: 50, opacity: 0, scale: 0.8}}
                animate={{y: 0, opacity: 1, scale: 1}}
                exit={{y: 50, opacity: 0, scale: 0.8}}
                transition={{duration: 0.3, ease: "easeInOut"}}
                onClick={(e) => e.stopPropagation()} // Остановить всплытие
            >
                <div className={"Wrapper"}>
                    <div className={"Container"}>
                        <CustomPageHeader title={'Каналы для размещения'}
                                          type={'BACK'}
                                          padding_xs
                                          onClickBack={handleJustClose}
                                          onClickInfoAction={openSearchModal}
                                          search/>
                        <IsLoadingContainer isLoading={isLoading}>
                            <main
                                className={"w-full h-full px-[16px] py-[24px] !overflow-auto custom-scrollBar pb-[70px] categories-height"}>
                                {
                                    channelsData.data.length > 0 && categoriesData ?
                                        <AvailableChannelsBlock channelsData={channelsData}
                                                                categoriesData={categoriesData}
                                                                toggleCheckBox={toggleCheckBox}/>
                                        : <EmptySearchChannelResult
                                            title={t('pages.blackListPage.emptySearchState.title')}
                                            subTitle={t('pages.blackListPage.emptySearchState.subTitle')}
                                            resetAll={resetForm}/>

                                }
                                <ButtonsBottomBlockOfPage title1={t('common.buttons.cancel')} title2={'Продолжить'}
                                                          onClickBack={handleJustClose}
                                                          continueFunc={handleSubmitAndClose}/>
                            </main>

                        </IsLoadingContainer>

                    </div>
                </div>
            </motion.div>
        </div>
    )
};

export const AvailableChannelsBlock: FC<{
    channelsData: AvailableChannelsType,
    categoriesData: ICategoriesResponseData[],
    toggleCheckBox: (id: string) => void
}> = ({channelsData, toggleCheckBox, categoriesData}) => {
    const {t} = useTranslation();

    const data: AvailableChannelsDataFilterType[] = [
        {id: 1, title: t('common.channelFilter.allChannels'), filterVal: "all", border: false},
        {id: 2, title: t('common.channelFilter.selectedChannels'), filterVal: "chosen", border: false},
        {id: 3, title: t('common.channelFilter.notSelectedChannels'), filterVal: "notChosen", border: false},
    ]
    const [filterState, setFilterState] = useState<AvailableChannelsFilterType>("all");

    const changeFilterState = (val: AvailableChannelsFilterType) => {
        setFilterState(val);
    };
    const filteredChannels = useMemo(() => {
        switch (filterState) {
            case "chosen":
                return channelsData.data.filter((channel) => channel.isChecked);
            case "notChosen":
                return channelsData.data.filter((channel) => !channel.isChecked);
            case "all":
            default:
                return channelsData.data;
        }
    }, [filterState, channelsData.data]);
    return (
        <>
            <CommonFilterBtnBlock filterState={filterState} data={data} onChange={changeFilterState}/>
            <div className={"w-full flex flex-col gap-2 mt-4"}>
                {
                    filteredChannels.map(item => {
                        return (
                            <AvailableChannelCard data={item} key={item.id} categoriesData={categoriesData}
                                                  toggleCheckBox={toggleCheckBox}/>
                        )
                    })
                }
            </div>
        </>
    )
}